let viewgird = [
  //
  // ----------
  // 环保管理
  {
    path: '/Eco_Overview',
    name: 'Eco_Overview',
    component: () => import('@/views/device/eco/Eco_Overview.vue')
  },
  {
    path: '/Eco_UsingWater',
    name: 'Eco_UsingWater',
    component: () => import('@/views/device/eco/Eco_UsingWater.vue')
  },
  {
    path: '/Eco_Wastewater',
    name: 'Eco_Wastewater',
    component: () => import('@/views/device/eco/Eco_Wastewater.vue')
  },
  {
    path: '/Eco_GeneralWaste',
    name: 'Eco_GeneralWaste',
    component: () => import('@/views/device/eco/Eco_GeneralWaste.vue')
  },
  {
    path: '/Eco_HazardousWaste',
    name: 'Eco_HazardousWaste',
    component: () => import('@/views/device/eco/Eco_HazardousWaste.vue')
  },
  {
    path: '/Eco_ExhaustWaste',
    name: 'Eco_ExhaustWaste',
    component: () => import('@/views/device/eco/Eco_ExhaustWaste.vue')
  },

  // 生产工况
  {
    path: '/Eco_ProductionMonitoring',
    name: 'Eco_ProductionMonitoring',
    component: () => import('@/views/device/eco/Eco_ProductionMonitoring.vue')
  },
  // 治污工况
  {
    path: '/Eco_PollutionControl',
    name: 'Eco_PollutionControl',
    component: () => import('@/views/device/eco/Eco_PollutionControl.vue')
  },
  {
    path: '/Eco_DeviceView',
    name: 'Eco_DeviceView',
    component: () => import('@/views/device/eco/Eco_DeviceView.vue')
  },
  {
    path: '/Eco_VideoView',
    name: 'Eco_VideoView',
    component: () => import('@/views/device/eco/Eco_VideoView.vue')
  },
  {
    path: '/Eco_RainwaterView',
    name: 'Eco_RainwaterView',
    component: () => import('@/views/device/eco/Eco_RainwaterView.vue')
  },
  {
    path: '/Eco_RainwaterView2',
    name: 'Eco_RainwaterView2',
    component: () => import('@/views/device/eco/Eco_RainwaterView2.vue')
  },
  {
    path: '/Eco_Factory',
    name: 'Eco_Factory',
    component: () => import('@/views/device/eco/Eco_Factory.vue')
  },
  {
    path: '/Eco_Ledger',
    name: 'Eco_Ledger',
    component: () => import('@/views/device/eco/Eco_Ledger.vue')
  },
  {
    path: '/Eco_Class',
    name: 'Eco_Class',
    component: () => import('@/views/device/eco/Eco_Class.vue')
  },
  {
    path: '/Eco_WasteLimit',
    name: 'Eco_WasteLimit',
    component: () => import('@/views/device/eco/Eco_WasteLimit.vue')
  },
  {
    path: '/Eco_EmissionLimit',
    name: 'Eco_EmissionLimit',
    component: () => import('@/views/device/eco/Eco_EmissionLimit.vue')
  },
  {
    path: '/Eco_ReceiveUnit',
    name: 'Eco_ReceiveUnit',
    component: () => import('@/views/device/eco/Eco_ReceiveUnit.vue')
  },
  {
    path: '/Eco_NationalWasteList',
    name: 'Eco_NationalWasteList',
    component: () => import('@/views/device/eco/Eco_NationalWasteList.vue')
  },
  {
    path: '/Eco_WasteWarehouse',
    name: 'Eco_WasteWarehouse',
    component: () => import('@/views/device/eco/Eco_WasteWarehouse.vue')
  },
  {
    path: '/Eco_WasteLists',
    name: 'Eco_WasteLists',
    component: () => import('@/views/device/eco/Eco_WasteLists.vue')
  },
  {
    path: '/Eco_WasteInLog',
    name: 'Eco_WasteInLog',
    component: () => import('@/views/device/eco/Eco_WasteInLog.vue')
  },
  {
    path: '/Eco_WasteOutLog',
    name: 'Eco_WasteOutLog',
    component: () => import('@/views/device/eco/Eco_WasteOutLog.vue')
  },
  {
    path: '/Eco_RubbishInLog',
    name: 'Eco_RubbishInLog',
    component: () => import('@/views/device/eco/Eco_RubbishInLog.vue')
  },
  {
    path: '/Eco_RubbishWarehouse',
    name: 'Eco_RubbishWarehouse',
    component: () => import('@/views/device/eco/Eco_RubbishWarehouse.vue')
  },
  {
    path: '/Eco_Rubbish',
    name: 'Eco_Rubbish',
    component: () => import('@/views/device/eco/Eco_Rubbish.vue')
  },
  {
    path: '/Eco_RubbishList',
    name: 'Eco_RubbishList',
    component: () => import('@/views/device/eco/Eco_RubbishList.vue')
  },
  {
    path: '/Eco_RubbishOutLog',
    name: 'Eco_RubbishOutLog',
    component: () => import('@/views/device/eco/Eco_RubbishOutLog.vue')
  },
  {
    path: '/Eco_Permits',
    name: 'Eco_Permits',
    component: () => import('@/views/device/eco/Eco_Permits.vue')
  },
];

export default viewgird;
